import pushToDataLayer from "./pushToDataLayer";
import itemDataTemplate from "./itemDataTemplate";
import { CURRENCY_CODE } from "./constants";
import { LoggedError } from "../errors/LoggedError";

const productComponentImpressionEvent = (
  rowIndex,
  savedItems,
  productsPerRow,
  leadingGridItemCount = 0
) => {
  if (rowIndex === null || rowIndex === undefined || !savedItems?.length) {
    throw new LoggedError(
      new Error("Missing product component impression event data"),
      LoggedError.error,
      {
        rowIndex,
        savedItemsCount: savedItems?.length
      }
    );
  }

  const localCurrencyCode = savedItems[0]?.price?.currency;

  pushToDataLayer({
    product_component_impression: {
      item_list_name: "wishlist",
      row: rowIndex + 1,
      ecommerce: {
        currency: CURRENCY_CODE,
        localCurrencyCode,
        items: savedItems.map((item, index) => {
          const absoluteItemIndex =
            index + rowIndex * productsPerRow - leadingGridItemCount;

          return itemDataTemplate(item, absoluteItemIndex);
        })
      }
    }
  });
};

export default productComponentImpressionEvent;
